import { NOMINATIONS as type } from '@/store/types';
import Nominations from '@/services/Api/Awards/Nominations';

const state = {
  data: [],
  loading: false,
};

const mutations = {
  [type.LOADING](state, data) {
    state.loading = data;
  },
  [type.SET](state, data) {
    state.data = data;
  },
  setItem(state, item) {
    const itemIndex = state.data.items.findIndex((r) => r.id === item.id);
    state.data.items.splice(itemIndex, 1, item);
  },
  [type.CLEAR]() {
    this.commit(type.SET, []);
  },
};

const actions = {
  fetchReviews({ commit }, params) {
    commit(type.LOADING, true);
    Nominations.all(params).then((response) => {
        const { status, data } = response.data;
        if (status === 200) {
          commit(type.SET, data);
        }
      })
      .finally(() => {
        commit(type.LOADING, false);
      });
  },
  createReview(context, params) {
    return Nominations.createReview(params.id, params.payload);
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
